export const getUrlParams = (url: string | null): URL | null => {
  try {
    if (!url) throw new Error('input value is null');

    // slightly modified the existing function httpify(url) from member.js in legacy code
    let httpUrl = '';
    // if the URL contains file:// protocol reference, its already a valid url
    if (url.startsWith('file://')) {
      httpUrl = url; // we've already got valid protocol at the beginning
    }
    // if the URL doesn't contain http:// or http://, add it at beginning. Useful when printing hrefs
    else if (url.startsWith('http://') || url.startsWith('https://')) {
      httpUrl = url; // we've already got valid http at the beginning
    } else if (url.indexOf('//') === 0) {
      // else if(strpos($url, "//") === 0)
      httpUrl = `http:${url}`;
    } else {
      httpUrl = `http://${url}`;
    }

    // const protoclRegex = /^[^:]+(?=:\/\/)/s;
    // const hasProtocol = protoclRegex.test(url);
    // if (!hasProtocol) {
    //   url = `http://${url}`;
    // }
    const urlObj = new URL(httpUrl);
    if (!urlObj.hostname) {
      return null;
    }
    return urlObj;
  } catch (e) {
    return null;
  }
};
